
import React, { useState } from "react";
import { Row, Col, UncontrolledTooltip, Button, CardHeader, Card, CardBody } from 'reactstrap';
import CopyToClipboard from "react-copy-to-clipboard";
import {
    putpost,
} from "services/http";
// import { PermissionContext, RolePermissions } from "appContext";
// import { pages, permissionType } from "../../../../../common/constant";
import { Dialog, CustomUpload } from "../../common/commonComponents";
import {
    failureToast, successToast
} from '../../common/utils/methods/toasterFunctions/function';
import SchedulerDateTime from "./SchedulerDateTime";
import { getUniqueKey } from "../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint, constants, commonMessages, regex } from "../../common/constant";
// import CommonInput from "views/pages/manage/common/formFeilds/input/commonInput";
// import CustomTextArea from "views/pages/manage/common/formFeilds/customTextarea";
// import style from "./bluckUpload.module.scss";


const NotificationBulkUpload = (props) => {


    const { description,
        isModalVisible = false,
        setModalVisible = () => { },
        getAllData = () => { },
        userPermissions,
        goBack = () => { },
        // isUploading, 
        // setISUploading = () => { }, 
        finalData,
        setIsConfirmationOpen = () => { },
        setOpenBulkUpload = () => { }
    } = props;

    const [isFileValid, setISFileValid] = useState(false);
    const [filename, setFileName] = useState("");
    const [file, setFile] = useState(null);
    const [progressBarStatus, setProgressBarStatus] = useState(0);
    // const [description, setDescription] = useState('');
    const [isUploading, setISUploading] = useState(false);
    const [epochTime, setEpochTime] = useState(null);

    const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);
    const [processIdCopied, setProcessIdCopied] = useState(false);
    const [processId, setProcessId] = useState(null);

    const dataToServer = {
        bulk: true,
        fileName: null,
        docType: "csv",
        keyValue: `notification_${getUniqueKey()}`,
        serviceName: 'BULK_NOTIFICATION_USER',
        sourceId: constants.sourceId
    };

    const handleFile = (e) => {
        try {
            if (e.name.split(".")[1] === "xlsx" || e.name.split(".")[1] === "csv") {
                if (e.name.length <= 100) {
                    let value = e.name.split(".")[0];

                    if (regex.alphaNumericWithSpaceAndUnderscore.test(value)) {
                        setFileName(value);
                        setFile(e);
                        setISFileValid(true);
                    } else {
                        failureToast("Only these special characters are allowed in file name: Space and Underscore ")
                        setFileName("");
                        setFile(null);
                        setISFileValid(false);
                    }
                } else {
                    failureToast("File name should be less than 100 characters.")
                    setFileName("");
                    setFile(null);
                    setISFileValid(false);
                }
            } else {
                failureToast("Only xlsx or csv files are allowed")
                setFileName("");
                setFile(null);
                setISFileValid(false);
            }
        } catch (e) {
            console.log(e)
        }
    };

    const saveFileAndReturnData = (data) => {

        const request = {
            "processId": data.processId,
            "status": "ACTIVE",
            "extId": "12123",
            "documentType": "xlsx",
            "signedUrl": "",
            "isProcess": true,
            "serviceName": "BULK_NOTIFICATION_USER",
            "processTagTypeId": Number(data.processId),
        }

        // const obj = {
        //     courseFeesProcessingDTO: { ...formData, description: finalData.description },
        //     courseFeeSupportingDocumentDtos: finalData.supportingDocument ?? []
        // }


        // setTimeout(()=>{
        //     console.log("obj",obj)
        //     setProgressBarStatus(100);
        // },2000)

        const url = constants.PRICING_FLAG_FOR_DMS ? `${endpoint.pricingUploadInfo.uploadInfo}` : `${endpoint.bulk_pricing_processing.uploadInfo}`

        putpost(
            endpoint.fetchS3Url.commonUploadDms,
            (res) => {
                if (res.code === 200 && res.data) {
                    setProgressBarStatus(100);
                    getAllData()
                    // setDescription('')
                    setProcessId(data.processId)
                    setIsSuccessModalVisible(true);
                    // successToast("File Uploaded Successfully")
                    // setOpenBulkUpload(false)
                    // successToast("File Uploaded Successfully")
                }
            },
            (res) => {
                setISUploading(false);
                setProgressBarStatus(0);
                setOpenBulkUpload(false)
                failureToast(res["message"]);
            },
            request,
            "post"
        );
    };

    const toggler = () => {
        setModalVisible(!isModalVisible);
        reset();
    }

    const reset = () => {
        setISFileValid(false);
        setFileName("Drag & Drop to Upload");
        setFile(null);
        setProgressBarStatus(0);
        setISUploading(false);
    };

    return (
        <>
            <CustomUpload
                // documentTitle="Upload Supporting Document"
                typeAllowed={'xlsx,csv'}
                isFileValid={isFileValid}
                filename={filename}
                file={file}
                progressBarStatus={progressBarStatus}
                setISFileValid={setISFileValid}
                setFileName={setFileName}
                setFile={setFile}
                setProgressBarStatus={setProgressBarStatus}
                isUploading={isUploading}
                setISUploading={setISUploading}
                handleFile={handleFile}
                dataToServer={dataToServer}
                saveHandler={saveFileAndReturnData}
                userPermissions={userPermissions}
                goBack={() => setOpenBulkUpload(false)}
                documentTitle={'Upload Notification Template'}
                isNotificationBulkUpload={true}
                description={epochTime ? `scheduledAt_${epochTime}` : description}
            >
                <SchedulerDateTime onDateTimeChange={(epoch) => setEpochTime(epoch)} />
            </CustomUpload>
            <Dialog isModalVisible={isSuccessModalVisible} toggle={() => { }} title="" size="md">
                <Row>
                    <h4 className="text-success alert mt-n4">
                        {commonMessages.pricingUploadSuccessfullMessage}
                    </h4>
                </Row>
                <Row className="flex-row">
                    <span className="text-info alert mt-n4 " style={{ width: '100%' }}>
                        {`Process ID`}
                        <CopyToClipboard
                            text={processId}
                            onCopy={() => setProcessIdCopied(processId)}
                        >
                            <button
                                className="btn-icon-clipboard"
                                data-clipboard-text={processId}
                                id="tooltip932383034"
                                type="button"
                            >
                                <div>
                                    <span>{processId}</span>
                                </div>
                            </button>
                        </CopyToClipboard>
                        <UncontrolledTooltip
                            delay={0}
                            trigger="hover focus"
                            target="tooltip932383034"
                        >
                            {processIdCopied === processId
                                ? "Copied"
                                : "Copy To Clipbord"}
                        </UncontrolledTooltip>
                    </span>
                </Row>
                <Row className="justify-content-center flex-row">
                    <Button
                        color="info"
                        size="sm"
                        type="button"
                        className="my-2"
                        onClick={() => {
                            reset();
                            setProcessId(null);
                            setProcessIdCopied(null);
                            setIsSuccessModalVisible(false);
                            setOpenBulkUpload(false);
                        }}
                    >
                        Close
                    </Button>
                </Row>
            </Dialog>
        </>

    );
};

export default NotificationBulkUpload;